<template>
  <v-container fluid>
    <template>
      <v-row>
        <v-col cols="6" class="pb-1 pt-0">
          <v-breadcrumbs :items="itemsBreadcrumbs" class="pl-0 pt-0 pb-1">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
                {{ item.text.toUpperCase() }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
        <v-col cols="6" class="pb-1 pt-0 h-100">
          <office-login></office-login>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="10" class="pt-1">
          <span class="headline font-weight-medium">Ventas con tarteja</span>
        </v-col>
        <v-col cols="2" class="pt-1">
          <v-btn
            dark
            color="#023145"
            width="140"
            class="float-right"
            @click="handleShowFilters"
          >
            Filtros
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pt-1">
          <v-btn
            dark
            color="success"
            width="140"
            class="float-right"
            :loading="is_download"
            @click="handleDownloadReport"
          >
            Descargar XLS
          </v-btn>
          <!--
                    <v-btn
                        dark 
                        color="blue" 
                        width="140" 
                        class="float-right mr-2"
                        @click="handleDownloadReportAccounting">
                        Reporte SISCONT
                    </v-btn>
                    -->
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pt-1">
          <v-card>
            <v-data-table
              :headers="headers"
              :items="sales"
              item-key="id"
              :items-per-page="10"
              class="elevation-1 w-table"
              height="57vh"
              fixed-header
              :loading="loading"
              loading-text="Cargando datos ... "
              :options.sync="options"
              :server-items-length="paginatedSaleTarjeta.total"
            >
              <template v-slot:top>
                <span
                  class="ml-3 pt-3 pb-3 subtitle-1 font-weight-bold w-title-table"
                >
                  Todas las ventas
                </span>
                <v-divider></v-divider>
              </template>

              <template v-slot:item.office_id="{ item }">
                <span class="label-office">{{ item.office.name }}</span>
              </template>

              <template v-slot:item.four_digits="{ item }">
                <span v-if="item.four_digits"
                  ><b> {{ item.four_digits }}</b></span
                >
              </template>
              <template v-slot:item.reference="{ item }">
                <span
                  ><b>{{ item.reference }}</b></span
                >
              </template>

              <template v-slot:item.registration_date="{ item }">
                <span>{{ item.registration_date | moment("DD/MM/YYYY") }}</span>
              </template>

              <template v-slot:item.hour="{ item }">
                <span>{{ item.registration_date | moment("hh:mm") }}</span>
              </template>

              <template v-slot:item.payment_amount="{ item }">
                <span>S/ {{ item.payment_amount }}</span>
              </template>

              <template v-slot:item.total="{ item }">
                <span>S/ {{ item.total }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <sales-filters ref="salesFilters"></sales-filters>
    <cancel-invoice ref="cancelInvoice"></cancel-invoice>
    <sales-accounting ref="salesAccounting"></sales-accounting>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import router from "@/router/index";
import SalesFilters from "../../../components/reports/SalesFiltersTarjeta";
import CancelInvoice from "../../../components/reports/CancelInvoice";
import OfficeLogin from "../../../components/auth/OfficeLogin";
import SalesAccounting from "../../../components/reports/SalesAccounting";

export default {
  name: "ReportSales",
  components: {
    SalesFilters,
    CancelInvoice,
    OfficeLogin,
    SalesAccounting,
  },
  data() {
    return {
      itemsBreadcrumbs: [
        {
          text: "Reportes",
          disabled: true,
          href: "",
        },
      ],
      headers: [
        { text: "LUGAR", value: "office_id", sortable: false },
        { text: "Nª TARJETA", value: "four_digits", sortable: false },
        { text: "REF.", value: "reference", sortable: false },
        { text: "FECHA", value: "registration_date", sortable: false },
        { text: "HORA", value: "hour", sortable: false },
        { text: "DOCUMENTO", value: "type_document", sortable: false },
        { text: "SERIE", value: "serie", sortable: false },
        { text: "N° DOC.", value: "correlative", sortable: false },
        //{ text: 'CLIENTE', value: 'customer_id', sortable: false },
        //{ text: 'RUC/DNI.', value: 'document', sortable: false },
        { text: "MÉTODO DE PAGO", value: "payment_method", sortable: false },
        {
          text: "DEBITADO",
          value: "payment_amount",
          sortable: false,
          align: "end",
        },
        { text: "TOTAL VENTA", value: "total", sortable: false, align: "end" },
      ],
      is_download: false,
      date_init: this.$moment()
        .subtract(7, "days")
        .format("YYYY-MM-DD"),
      date_end: this.$moment().format("YYYY-MM-DD"),
      loading: false,
      options: {},
      dataTable: { page: 1 },
      pageSelected: 1,
      perPage: 10,
    };
  },
  watch: {
    options: {
      handler() {
        this.loading = true;
        this.perPage = this.options.itemsPerPage;
        this.pageSelected = this.options.page;
        this.getSalesTarjeta({
          ...this.filters,
          paginatedSaleTarjeta: true,
          page: this.pageSelected,
          itemsPerPage: this.perPage,
        })
          .then((res) => (this.loading = false))
          .catch((err) => (this.loading = false));
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("authentication", ["company_id", "office_id"]),
    ...mapState("report-sales", [
      "sales",
      "filters",
      "sale",
      "file_sales",
      "paginatedSaleTarjeta",
    ]),
  },
  methods: {
    ...mapActions("customers", ["getCustomers"]),
    ...mapActions("offices", ["getOffices"]),
    ...mapActions("sedes", ["getSedes"]),
    ...mapActions("saleoptions", ["getSalesOptions"]),
    ...mapActions("report-sales", [
      "getSales",
      "getSalesTarjeta",
      "setFilters",
      "selectSale",
      "getSaleDetail",
      "salesExcel",
      "emptyFileSales",
      "setSales",
    ]),
    handleShowFilters() {
      this.$refs.salesFilters.show();
    },
    handleViewDetail(sale) {
      this.selectSale(sale);
      router.push("/app/reportes/detalle-ventas");
    },
    async handleDownloadReport() {
      this.is_download = true;
      this.emptyFileSales();
      let filters_data = Object.assign({}, this.filters);
      filters_data.company_id = this.company_id;
      await this.salesExcel(filters_data);
      this.is_download = false;
      if (this.file_sales) {
        let url = process.env.VUE_APP_API_URL_BASE + "/" + this.file_sales;
        window.open(url);
      }
    },
    handleCancelInvoice(sale) {
      this.$refs.cancelInvoice.show(sale);
    },
    handleDownloadReportAccounting() {
      this.$refs.salesAccounting.show();
    },
  },
  created() {
    this.getCustomers();
    // this.setFilters({
    //   company_id: this.company_id,
    //   office_id: this.office_id,
    //   date_from: this.date_init,
    //   date_until: this.date_end,
    // });
    //this.getSales(this.filters);
    this.getSalesTarjeta(this.filters);
    this.getOffices({
      company_id: this.company_id,
    });
    this.getSalesOptions();
  },
  destroyed() {
    this.setSales([]);
  },
};
</script>

<style scoped>
.label-office {
  color: #2196f3;
}

.sale-cancel {
  color: #f44336;
  font-weight: 600;
}
</style>
